import { type ModalId } from '@heidi/schema/ml-scribe';

/**
 * Seen-state id for the Library "Library is now My Sources" changeboarding
 * banner (T4 onboarding/education, banner format, not queued).
 *
 * PROVISIONAL cast until ml-scribe `shared/enums/modal_tracking.py` gains the
 * member and `pnpm run schema:dev` picks it up; then swap for `ModalId.X`.
 * The string is frozen — it keys `seen_modals`.
 */
export const MY_SOURCES_CHANGEBOARDING_BANNER_MODAL_ID =
  'T4_CUSTOM_AUDIENCE_MY_SOURCES_CHANGEBOARDING_BANNER' as ModalId;
